import Vue from 'vue'
import vuetify from '@/plugins/vuetify'
import Vuelidate from 'vuelidate'
import VueEvents from 'vue-events'
import VueTour from 'vue-tour'
import VueCookies from 'vue-cookies'
import AsyncComputed from 'vue-async-computed'

import router from './router'
import i18n from '@/locale'
import store from '@/store/index.js'
import App from '@/layouts/App.vue'
import API from '@/services/api'
import Auth from '@/services/auth'

import { Notifier } from '@airbrake/browser'
import './registerServiceWorker'

import '@/filters'

import '@/styles/main.scss'
//import '@/styles/main.css'

Vue.config.productionTip = false

//- Airbrake error logging
if (process.env.VUE_APP_AIRBRAKE_PROJECT && process.env.VUE_APP_AIRBRAKE_KEY) {
  let airbrake = new Notifier({
    environment: 'production',
    projectId: process.env.VUE_APP_AIRBRAKE_PROJECT,
    projectKey: process.env.VUE_APP_AIRBRAKE_KEY
  });  
  Vue.config.errorHandler = function (err, vm, errinfo) {
    airbrake.notify({
      context: { component: 'registret' },
      error: err,
      params: {info: errinfo}
    });
  }
}
//- Site tour
require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)

//- Validations for forms and such
Vue.use(Vuelidate)
Vue.use(VueEvents)
Vue.use(VueCookies)

//- You can have computed properties in Vue that are computed asynchronously
Vue.use(AsyncComputed)

//- The vue instance
// Initialize what needs to be initialized and start up application
Promise.all([
  API.init(),
  Auth.init(),
  store.dispatch('init')
])
  .then(
    new Vue({
      vuetify,
      i18n,
      router,
      store,
      created() {
        API.dialog = this.$dialog
        API.router = this.$router
        API.store = this.$store
        API.events = this.$events
  
        // grab user data from local storage
        const userString = localStorage.getItem('user')

        // check to see if there is indeed a user
        if (userString) {
          // parse user data into JSON and restore user data with Vuex
          //const userData = JSON.parse(userString)
          //this.$store.commit('SET_USER_DATA', userData)
          // Get user to see if we have correct credentials
          //BackService.getUser(userData.id)
          //  .catch(error => {
          //    console.log('Vue created - failed to get user: ' + error)
          //    this.$store.commit('LOGOUT')
          //  })
        }
      },
      render: h => h(App)
    }).$mount('#app')
  )